import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c8cdc4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-global-skeleton tw-w-full tw-h-full" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = {
  key: 1,
  class: "container tw-overflow-y-hidden"
}

import { ApexOptions } from "apexcharts";
import { nextTick, PropType, ref, watch } from "vue";

export interface IChartSeries {
  name: string;
  data: number[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'lineChart',
  props: {
  isPrint: {
    type: Boolean,
    required: false,
    default: false,
  },
  chartId: {
    type: Number,
    required: false,
    default: 1,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  height: {
    type: [Number, String],
    required: true,
  },
  series: {
    type: Object as PropType<IChartSeries[]>,
    required: true,
  },
  chartOptions: {
    type: Object as PropType<ApexOptions>,
    default: () => ({
      stroke: { width: 3, curve: "smooth" },
      forecastDataPoints: { count: 5 },
      chart: { toolbar: { show: false } },
      xaxis: {
        type: "datetime",
        categories: [
          "1/11/2000",
          "2/11/2000",
          "3/11/2000",
          "4/11/2000",
          "5/11/2000",
          "6/11/2000",
          "7/11/2000",
          "8/11/2000",
          "9/11/2000",
          "10/11/2000",
          "11/11/2000",
          "12/11/2000",
          "1/11/2001",
          "2/11/2001",
          "3/11/2001",
          "4/11/2001",
          "5/11/2001",
          "6/11/2001",
        ],
        tickAmount: 10,
        labels: {
          formatter: function (value, timestamp, opts) {
            const monthNames = [
              "J",
              "F",
              "M",
              "A",
              "M",
              "J",
              "J",
              "A",
              "S",
              "O",
              "N",
              "D",
            ];

            return monthNames[new Date(timestamp).getMonth()];
          },
        },
      },
      yaxis: { min: -10, max: 40 },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          gradientToColors: ["#FDD835"],
          shadeIntensity: 1,
          type: "horizontal",
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 100, 100, 100],
        },
      },
      grid: {
        padding: { left: 10, right: 20, top: 0, bottom: -5 },
      },
    }),
    required: true,
  },
  heightLoading: {
    type: Number || String,
    default: 0,
  },
  classChart: {
    type: String,
    default: "",
  },
  isChangeSize: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const chartRef: any = ref(null);

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tw-flex tw-w-full",
        style: _normalizeStyle(`height: ${__props.heightLoading ? __props.heightLoading + 'px' : '100%'}`)
      }, _hoisted_2, 4))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        (_openBlock(), _createBlock(_component_apexchart, {
          key: __props.chartId,
          ref_key: "chartRef",
          ref: chartRef,
          width: "100%",
          height: __props.height,
          type: 'line',
          options: __props.chartOptions,
          series: __props.series,
          class: _normalizeClass(`!tw-min-h-[0px] ${__props.classChart}`)
        }, null, 8, ["height", "options", "series", "class"]))
      ]))
}
}

})